import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPatient: JSON.parse(localStorage.getItem("selectedPatient")) || null,
};

const patientSlice = createSlice({
  name: "patient",
  initialState,
  reducers: {
    setSelectedPatient: (state, action) => {
      state.selectedPatient = action.payload;
      localStorage.setItem("selectedPatient", JSON.stringify(action.payload));
    },
    clearPatients: (state) => {
      state.selectedPatient = null;
      localStorage.removeItem("selectedPatient");
      localStorage.removeItem("MRNO");
      localStorage.removeItem("name");
      localStorage.removeItem("email");
    },
  },
});

export const { setSelectedPatient, clearPatients } = patientSlice.actions;

export default patientSlice.reducer;
